import React from "react";
import { Dropdown, MenuProps } from "antd";
import styles from "./FindInnLink.module.scss";

export const FindInnLink: React.FC = () => {
	const openLink = (url: string) => {
		window.open(url, "_blank", "noopener,noreferrer");
	};

	const items: MenuProps["items"] = [
		{
			type: "group",
			label: (
				<ul className={styles.dropdownList}>
					<li className={styles.dropdownItem}>1. Перейдите в личный кабинет Госуслуг или ФНС</li>
					<li className={styles.dropdownItem}>2. Скопируйте ИНН из раздела «Документы»</li>
				</ul>
			),
			children: [
				{
					key: "fns",
					label: (
						<button
							type="button"
							className={styles.option}
							onClick={() => openLink("https://lkfl2.nalog.ru/lkfl")}
						>
							Открыть сайт ФНС
						</button>
					),
				},
				{
					key: "gosuslugi",
					label: (
						<button
							type="button"
							className={styles.option}
							onClick={() => openLink("https://www.gosuslugi.ru/")}
						>
							Открыть Госуслуги
						</button>
					),
				},
			],
		},
	];

	return (
		<Dropdown
			menu={{ items }}
			trigger={["click"]}
			placement="bottomLeft"
			overlayClassName={styles.dropdown}
		>
			<button type="button" className={styles.linkButton}>
				Где найти ИНН?
			</button>
		</Dropdown>
	);
};
